import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import modifyStatus from '../utils/modifyStatus';
import API_KEY from '../api/API_KEY';
import Spinner from '../utils/Spinner';
import projects from '../data/projects';
import Projects from './Projects';
import GetInTouch from './GetInTouch';
import { AiOutlineArrowDown } from 'react-icons/ai';

const baseURL = `https://api.openweathermap.org/data/2.5/forecast?zip=11225&units=imperial&APPID=${API_KEY}`

const Home = ({handleInputChange, radius}) => {
    const [ weather, setWeather ] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
  
    useEffect(() => {
      const fetchData = async () => {
        setIsError(false);
        setIsLoading(true);
   
        try {
          const result = await axios(baseURL);
          setWeather(result.data.list[0].weather[0].main);
        } catch (error) {
          setIsError(true);
        }
        setIsLoading(false);
      };
      fetchData();
    }, []);

    const arrowRef = useRef();
    const handleArrowClick = () => {
      arrowRef.current.scrollIntoView({ behavior: 'smooth' });
    };

    return (
    isLoading || isError ? <Spinner /> : ( 
        <>
        <section className='home-section'>
            <div className='home-description' style={{borderRadius: `${radius}px`}}>
                <p>Hey there, my name is Luka and I'm a software engineer, currently based in&nbsp;
                <a href='https://openweathermap.org/' target='_blank' rel="noopener noreferrer" className='status-animation blink-1'>{modifyStatus(weather)}</a>
                &nbsp;Brooklyn, New York.</p>
                <p>I combine my experience in development, data analytics, finance, and entrepreneurship to create, problem solve, and tell stories through design and computation.</p>
                <input className='input-slider' type='range' min='5' max='150' value={radius} onChange={handleInputChange}></input> 
            </div>
            <h1 onClick={handleArrowClick} className='arrow-icon'><AiOutlineArrowDown /></h1>
        </section>
        <h2 className='project-title' ref={arrowRef}>Projects</h2>
        <section className='projects-section'>
            {projects.map(project => <Projects key={project.id} project={project} img={project.image} radius={radius}/>)}
         </section>
          <GetInTouch />
        </>
        )
    )
}

export default Home;
